
export class AutomatKind {
    constructor() {
    }
    _id?:string;
    name: string;
    description: string;
    capacity: number;
    productCount: number;
    column: number;
    indexKey: number;
    isHot: boolean;
    row: number;
    createdAt: string;
    updatedAt: string;
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/automatKind.ts